import React, { Fragment } from 'react'
import actions from 'redux/actions'
import { useConnect } from 'sb-redux-hook'
import { useCallback, useEffect } from 'sb-hooks'
import { constants, links, mixpanel, formatPrice } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Overlay from 'components/_new/layout/Overlay/Overlay'
import ModalContainer from 'components/_new/modal/ModalContainer/ModalContainer'
import Modal from 'components/_new/modal/Modal/Modal'
import Box from 'components/_new/layout/Box/Box'
import Title from 'components/_new/typography/deprecated/Title/Title'
import Text from 'components/_new/typography/Text/Text'
import Image from 'components/_new/ui/Image/Image'
import Button from 'components/_new/Button/Button'

import Countdown from 'pages/bundle/FlashSaleBundlePage/BundleInfo/Countdown/Countdown'

import s from './FlashSaleModal.scss'
import messages from './messages'


const FlashSaleModal = () => {
  useEffect(() => {
    mixpanel.track(constants.analyticsEvents.flashSale.popup)
  }, [])

  const { title, image, timeLeft, startDate, priceCents, discountCents } = useConnect({
    title: 'view.flashSaleBundlePage.name',
    image: (state) => state.view.flashSaleBundlePage.media ? state.view.flashSaleBundlePage.media[0] : null,
    timeLeft: 'view.flashSaleBundlePage.timeLeft',
    startDate: 'view.flashSaleBundlePage.startDate',
    priceCents: 'view.flashSaleBundlePage.price',
    discountCents: 'view.flashSaleBundlePage.discount',
  })

  const close = useCallback(() => {
    const startDateTime = new Date(startDate).getTime()

    actions.models.modals.close(constants.modals.humble.flashSale)
    actions.models.ui.setClosedPopup(`${constants.modals.humble.flashSale}${startDateTime}`)
  }, [ startDate ])

  const onClick = useCallback(() => {
    mixpanel.track(constants.analyticsEvents.flashSale.popupClick)
    close()
  }, [ close ])

  const discount  = formatPrice(discountCents, true)
  const price     = formatPrice(priceCents, true)
    .replace('.00', '')

  return (
    <Fragment>
      <ModalContainer>
        <Overlay onClick={close} />
        <Modal onClose={close}>
          <div className={s.title}>
            <Title message={messages.title} size="lg" />
            <Countdown className={s.countdown} timeLeft={timeLeft} brandColor />
            <Title message={messages.subTitle} size="lg" />
          </div>
          <Text
            className={s.text}
            message={{ ...messages.text, values: { title, price, discount } }}
            html
          />
          {
            image ? (
              <Box className={s.imageContainer} mt="24">
                <Image className={s.imageSolo} src={image} mW={400} w={600} x2 />
              </Box>
            ) : (
              <div className={s.image}>
                <FormattedHTMLMessage className={s.discount} {...messages.discount} />
              </div>
            )
          }
          <Box mt="36">
            <Button
              title={messages.buttonTitle}
              size="md"
              color="brand"
              rightIcon="rightArrowSmall"
              fullWidthOnMobile
              to={links.flashSale}
              onClick={onClick}
            />
          </Box>
        </Modal>
      </ModalContainer>
    </Fragment>
  )
}


export default FlashSaleModal
